import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "hidden md:flex" }
const _hoisted_3 = { class: "mb-5 font-bold" }
const _hoisted_4 = { class: "flex flex-col gap-2 min-h-[100%] max-h-[500px] overflow-auto scroll-style p-2" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = { class: "border border-l-8 border-h-primary-500 w-full rounded-md flex items-center justify-between p-4 gap-2" }
const _hoisted_7 = { class: "flex items-center text-start gap-2 max-w-full" }
const _hoisted_8 = { class: "break-words line-clamp-1" }
const _hoisted_9 = { class: "mt-2 p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_ctx.isAdaptativeLearning)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "btn-outline p-button-sm flex gap-2",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onToggleFilter($event)), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { name: "md-playlistplay-twotone" }),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Materiais assistidos",
          en: "Watched materials",
        })), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_OverlayPanel, {
          ref: "panel",
          style: {"width":"450px","z-index":"-1"},
          breakpoints: { '960px': '75vw' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.learningObjective?.name), 1),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlyWatched(), (material, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    ref_for: true,
                    ref: "materials",
                    class: _normalizeClass(`${
              _ctx.currentMaterial?.id === material?.id ? 'bg-yellow-50' : 'bg-white'
            } w-full my-1 rounded-md`),
                    title: material?.name,
                    onClick: ($event: any) => (_ctx.chooseMaterial(index))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_icon, {
                          name: _ctx.materialsUtils.getIcon(material?.file?.mimetype),
                          class: "text-primary-400",
                          scale: 1.5
                        }, null, 8, ["name", "scale"]),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(material?.name), 1)
                      ]),
                      (material?.concluded)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            name: "hi-solid-check-circle",
                            class: "text-green-500",
                            scale: 1.2
                          }, null, 8, ["scale"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_5))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  class: "btn-outline gap-2 w-full",
                  onClick: _ctx.onCloseStudentMap
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      name: "md-openinnew",
                      class: "text-primary-400"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Ver todo mapa de conteúdo",
                en: "View full content map",
              })), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
}